import { render, staticRenderFns } from "./NotFoundPage.vue?vue&type=template&id=8e367c50"
import script from "./NotFoundPage.vue?vue&type=script&lang=js"
export * from "./NotFoundPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8e367c50')) {
      api.createRecord('8e367c50', component.options)
    } else {
      api.reload('8e367c50', component.options)
    }
    module.hot.accept("./NotFoundPage.vue?vue&type=template&id=8e367c50", function () {
      api.rerender('8e367c50', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/NotFoundPage.vue"
export default component.exports